export const openMenu = () => {
  document.querySelector(".popup-mobile-menu").classList.add("active");
};
export const closeMenu = () => {
  document.querySelector(".popup-mobile-menu").classList.remove("active");
};
